angular.module('controllers').controller('driverTraveledController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$route', '$routeParams', '$location',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $route, $routeParams, $location) {
		$rootScope.path = '/driver-traveled';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'driver-traveled';
		$scope.pathTemplate = 'distribution/driverstraveled';
		$scope.title = 'Curse soferi';
		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'driver_last_name';
		$scope.defaultItem = 10;
    $rootScope.typeId = 'id';
		$scope.classAction = 'td-big';
		$scope.columns = {
            //'id':{'label':'Id', 'filter':1, 'filterType':'input'},
            'traveled_date':{'label': 'Data', 'filter': 1, 'filterType': 'input'},
            'driver_image':{'label':'Imagine', 'filter':0},
            'driver_name':{'label': 'Nume sofer', 'filter': 1, 'filterType': 'input'},
            'assigned_number':{'label': 'Numar atribuit', 'filter': 1, 'filterType': 'input'},
            //'car_id': {'label': 'Masina', 'filter': 1, 'filterType': 'select', 'associate': 1, 'relation': 'car', 'colRelation': 'car_no'},
            'car_no': {'label': 'Masina', 'filter': 1, 'filterType': 'input'},
            'car_type': {'label': 'Tip masina', 'filter': 1, 'filterType': 'select', 'associate': 1},
            'km_start':{'label': 'KM start', 'filter': 1, 'filterType': 'input'},
            'km_end':{'label': 'KM end', 'filter': 1, 'filterType': 'input'}
            /*'status':{'label':'Status', 'filter':1, 'filterType':'select'}*/
        };

		/*$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];*/

        $scope.additionals['car_type'] = [
            {'id':'', 'value' : ''},
            {'id':'0', 'value' : 'Masina '+$rootScope.nameProject},
            {'id':'1', 'value' : 'Masina '+$rootScope.nameProject+' chirie'},
            {'id':'2', 'value' : 'Masina Personala'}
        ];
		$scope.columns.car_type.options = $scope.additionals['car_type'];

		//$scope.maxDate = new Date();
		$scope.minDate = '2010-01-01';
		var current_init_date = new Date();//'2021-04-15'
		current_init_date.setHours(0, 0, 0, 0);
		$scope.search.dateFrom = current_init_date;

		if (angular.isUndefined($scope.additionals['assigned_number'])) {
			$scope.additionals['assigned_number'] = [];
		}
		for (var i = 1; i <= 25; i++) {
			$scope.additionals['assigned_number'][i] = {'id':i, 'value' : i};
		}

		$scope.search.order = 'asc';
		$scope.additionals['content_type'] = 'form-urlencoded';
		$scope.additionals['publicPath'] = '/images/drivers';
    $scope.additionals['columnDisplay'] = 'driver_first_name';
    $scope.additionals['columnDisplaySec'] = 'driver_last_name';
		$scope.additionals['publicPathThumb250x250'] = $scope.additionals['publicPath']+'/thumb250x250';
		$scope.additionals['publicPathThumb180x180'] = $scope.additionals['publicPath']+'/thumb180x180';
		$scope.additionals['publicPathFile'] = '/costs/drivers';

		/* get dependent fields */
		$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {
					$scope.additionals['cars'] = data.cars;
					$scope.additionals['drivers'] = data.drivers;
				});
		}

        $scope.additionals['costCategories'] = [
            {'id':0, 'value' : ''},
            {'id':1, 'value' : 'General'},
            {'id':2, 'value' : 'Combustibil'}
        ];
        $scope.additionals['costCategoriesSup'] = {};
        $scope.additionals['costCategoriesSup'].options = $scope.additionals['costCategories'];

				$scope.additionals['car_type_string'] = JSON.stringify($scope.columns.car_type.options);
				$scope.additionals['cost_category_string'] = JSON.stringify($scope.additionals['costCategoriesSup'].options);

		/* autocomplete */
		function createFilterFor(query) {
			var lowercaseQuery = angular.lowercase(query);
			return function filterFn(item) {
				return item.driver_name.indexOf(lowercaseQuery) >= 0;
			};
		}
		$scope.additionals['getDrivers'] = function() {
			Crud.get($scope.path+'/getDrivers')
				.success(function (data) {
					$scope.additionals['drivers'] = [];
					angular.forEach(data.drivers, function (item, key) {
						$scope.additionals['drivers'][key] = {
							'id': item['id'],
							'driver_name': item['driver_detail']['driver_first_name'].toLowerCase() + ' ' + item['driver_detail']['driver_last_name'].toLowerCase(),
							'display': item['driver_detail']['driver_first_name'] + ' ' + item['driver_detail']['driver_last_name']
						};
					});

					/* autocomplete */
					function querySearch(query) {
						var results = query ? $scope.additionals['drivers'].filter(createFilterFor(query)) : [];
						return results;
					}

					$scope.additionals['searchDriver'] = querySearch;
					$scope.additionals['errors'] = {};
					/* end autocomplete */
				});
		}

		/* end autocomplete */

		/* close field */
		$scope.additionals['closeField'] = function (paramName, paramId) {
			$scope.org[paramName] = '';
			$scope.org[paramId] = '';
		}

		$scope.additionals['searchTerm'];
		$scope.additionals['clearSearchTerm'] = function() {
			$scope.additionals['searchTerm'] = '';
		};
		$scope.additionals['onSearchChange'] = function(ev) {
			ev.stopPropagation();
		};

		/* add multiple forms */
		$scope.additionals['cloneItem'] = function (model) {
			var itemToClone = {};
			$scope.additionals[model].push(itemToClone);
		}
		$scope.additionals['removeItem']= function (itemIndex, model) {
				$scope.additionals[model].splice(itemIndex, 1);
				if (!angular.isUndefined($scope.costs)) {
					$scope.costs.splice(itemIndex, 1);
				}
        if (!angular.isUndefined($scope.cashings)) {
            $scope.cashings.splice(itemIndex, 1);
        }
		}

		/* add costs to driver */
		$scope.addCostsModel = function (ev, path, model, section, mode_action) {

			if (!angular.isUndefined(mode_action)) {
				$scope.mode_action = mode_action;
			}

			if($scope.mode_action == 'page') {
				$scope.controlSH = true;
				$scope.action = 'addCosts';
        angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
				$scope.additionals['invalid'] = '';
				var currentModel = {};
				angular.forEach(model, function (item, key) {
					currentModel[key] = item;
				});
				$scope.modelData = currentModel;

				$scope.additionals['costs'] = $scope.modelData.costs;
        if (angular.isUndefined($scope.additionals['costs'])) {
            $scope.additionals['costs'] = [];
        }
        if ($scope.additionals['costs'].length == 0) {
            $scope.additionals['costs'][0] = {};
        }

				$scope.cancel = function () {
					$scope.modelData = {};
					$scope.errors = {};
					$scope.controlSH = false;
				};

				$scope.costs = [];
				$scope.addCosts = function () {
          $scope.additionals['buttonDisabled'] = true;
					$scope.isLoading = true;
					$scope.post = {};
					$scope.post['costs'] = $scope.modelData['costs'];
					$scope.post['driver_traveled_id'] = $scope.modelData['id'];
					$scope.post['route'] = 'costs';

					Crud.post('form-urlencoded', $scope.post, $scope.path + '/costs')
						.success(function (data) {
								$scope.isLoading = false;
								if (!angular.isUndefined(data.invalid)) {
									$scope.additionals['invalid'] = data.invalid;
								}
								//$scope.modelData = {};
								if (!angular.isUndefined($scope.modelData)) {
									angular.forEach($scope.modelData['costs'], function (item, key) {
											 $scope.modelData['costs'][key] = {};
											 if(key > 0) {
												 	delete $scope.modelData['costs'][key];
											 }
									});
									if (!angular.isUndefined(data.currentModel)) {
											if (data.currentModel['costs'].length > 0) {
													angular.forEach(data.currentModel['costs'], function (item, key) {
												 			$scope.modelData['costs'][key] = item;
												 });
											 }
										}
								}
								$scope.errors = {};
								$scope.isLoading = false;
								$scope.controlSH = false;
	              $scope.additionals['buttonDisabled'] = false;
						})
						.error(function (data) {
								$scope.isLoading = false;
								$scope.errors = data.errors;
	              $scope.additionals['buttonDisabled'] = false;
						});
				}
			}

			if($scope.mode_action == 'dialog') {
				$scope.additionals['invalid'] = '';
				var currentModel = {};
				angular.forEach(model, function (item, key) {
					currentModel[key] = item;
				});
				$mdDialog.show({
					controller: DialogController,
					templateUrl: 'costDialog.tmpl.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					locals: {
						pathTemplate: $scope.pathTemplate,
						section: section,
						model: currentModel,
						selected: $scope.selected,
						additionals: $scope.additionals
					}
				}).then(function () {
					if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
						if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models.data)) {
							$scope.getElement($scope.models.data, currentModel, $rootScope.typeId);
						}
						if (!angular.isUndefined($scope.modelData)) {
							$scope.modelData = currentModel;
						}
					}
				});
				DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'section', 'model', 'selected', 'additionals'];
				function DialogController($scope, $mdDialog, pathTemplate, section, model, selected, additionals) {
					$scope.pathTemplate = pathTemplate;
					$scope.modelData = model;
					$scope.additionals = additionals;
					$scope.selected = selected;
					$scope.section = section;

					$scope.cancel = function () {
						$mdDialog.cancel();
					};

					$scope.additionals['costs'] = $scope.modelData.costs;
					if (!angular.isUndefined($scope.additionals['costs'])) {
						if ($scope.additionals['costs'].length == 0) {
							$scope.additionals['costs'][0] = {};
						}
					}

					$scope.costs = [];
					$scope.addCosts = function () {
            $scope.additionals['buttonDisabled'] = true;
						$scope.isLoading = true;
						$scope.post = {};
						$scope.post['costs'] = $scope.modelData['costs'];
						$scope.post['driver_traveled_id'] = $scope.modelData['id'];
						$scope.post['route'] = 'costs';

						Crud.post('form-urlencoded', $scope.post, path + '/costs')
							.success(function (data) {

								$scope.isLoading = false;
								if (!angular.isUndefined(data.invalid)) {
									$scope.additionals['invalid'] = data.invalid;
								}
								//$scope.modelData = {};
								if (!angular.isUndefined($scope.modelData)) {
									angular.forEach($scope.modelData['costs'], function (item, key) {
											 $scope.modelData['costs'][key] = {};
											 if(key > 0) {
												 	delete $scope.modelData['costs'][key];
											 }
									});
									if (!angular.isUndefined(data.currentModel)) {
											if (data.currentModel['costs'].length > 0) {
													angular.forEach(data.currentModel['costs'], function (item, key) {
												 			$scope.modelData['costs'][key] = item;
												 });
											 }
										}
								}
								$scope.errors = {};
								$scope.isLoading = false;
								$mdDialog.hide();
                $scope.additionals['buttonDisabled'] = false;
							})
							.error(function (data) {
								$scope.isLoading = false;
								$scope.errors = data.errors;
                $scope.additionals['buttonDisabled'] = false;
							});
					}
				}
			}
		};

        /* add cashing to driver */
        $scope.addCashingModel = function (ev, path, model, section, mode_action) {
            if (!angular.isUndefined(mode_action)) {
                $scope.mode_action = mode_action;
            }

            if($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'addCashings';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
                $scope.additionals['invalid'] = '';
                var currentModel = {};
                angular.forEach(model, function (item, key) {
                    currentModel[key] = item;
                });
                $scope.modelData = currentModel;

                $scope.additionals['cashings'] = $scope.modelData.cashings;
                if (angular.isUndefined($scope.additionals['cashings'])) {
                    $scope.additionals['cashings'] = [];
                }
                if ($scope.additionals['cashings'].length == 0) {
                    $scope.additionals['cashings'][0] = {};
                }

                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };

                $scope.cashings = [];
                $scope.addCashings = function () {
                    $scope.additionals['buttonDisabled'] = true;
                    $scope.isLoading = true;
                    $scope.post = {};
                    $scope.post['cashings'] = $scope.modelData['cashings'];
                    $scope.post['driver_traveled_id'] = $scope.modelData['id'];
                    $scope.post['route'] = 'cashings';

                    Crud.post('form-urlencoded', $scope.post, $scope.path + '/cashings')
                        .success(function (data) {
                            $scope.isLoading = false;
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            }
                            //$scope.modelData = {};
														if (!angular.isUndefined($scope.modelData)) {
															angular.forEach($scope.modelData['cashings'], function (item, key) {
																	 $scope.modelData['cashings'][key] = {};
																	 if(key > 0) {
																		 	delete $scope.modelData['cashings'][key];
																	 }
															});
															if (!angular.isUndefined(data.currentModel)) {
																	if (data.currentModel['cashings'].length > 0) {
																			angular.forEach(data.currentModel['cashings'], function (item, key) {
																		 			$scope.modelData['cashings'][key] = item;
																		 });
																	 }
																}
														}
                            $scope.errors = {};
                            $scope.isLoading = false;
                            $scope.controlSH = false;
                            $scope.additionals['buttonDisabled'] = false;
                        })
                        .error(function (data) {
                            $scope.isLoading = false;
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                        });
                }
            }

            if($scope.mode_action == 'dialog') {
                $scope.additionals['invalid'] = '';
                var currentModel = {};
                angular.forEach(model, function (item, key) {
                    currentModel[key] = item;
                });
                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'cashingDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        section: section,
                        model: currentModel,
                        selected: $scope.selected,
                        additionals: $scope.additionals
                    }
                }).then(function () {
                    if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models.data)) {
                            $scope.getElement($scope.models.data, currentModel, $rootScope.typeId);
                        }
                        if (!angular.isUndefined($scope.modelData)) {
                            $scope.modelData = currentModel;
                        }
                    }
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'section', 'model', 'selected', 'additionals'];
                function DialogController($scope, $mdDialog, pathTemplate, section, model, selected, additionals) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.modelData = model;
                    $scope.additionals = additionals;
                    $scope.selected = selected;
                    $scope.section = section;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    $scope.additionals['cashings'] = $scope.modelData.cashings;
                    if (!angular.isUndefined($scope.additionals['cashings'])) {
                        if ($scope.additionals['cashings'].length == 0) {
                            $scope.additionals['cashings'][0] = {};
                        }
                    }

                    $scope.cashings = [];
                    $scope.addCashings = function () {
                        $scope.additionals['buttonDisabled'] = true;
                        $scope.isLoading = true;
                        $scope.post = {};
                        $scope.post['cashings'] = $scope.modelData['cashings'];
                        $scope.post['driver_traveled_id'] = $scope.modelData['id'];
                        $scope.post['route'] = 'cashings';

                        Crud.post('form-urlencoded', $scope.post, path + '/cashings')
                            .success(function (data) {

                                $scope.isLoading = false;
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                }
                                //$scope.modelData = {};
																if (!angular.isUndefined($scope.modelData)) {
																	angular.forEach($scope.modelData['cashings'], function (item, key) {
																			 $scope.modelData['cashings'][key] = {};
																			 if(key > 0) {
																				 	delete $scope.modelData['cashings'][key];
																			 }
																	});
																	if (!angular.isUndefined(data.currentModel)) {
																			if (data.currentModel['cashings'].length > 0) {
																					angular.forEach(data.currentModel['cashings'], function (item, key) {
																				 			$scope.modelData['cashings'][key] = item;
																				 });
																			 }
																		}
																}
                                $scope.errors = {};
                                $scope.isLoading = false;
                                $mdDialog.hide();
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                            });
                    }
                }
            }
        };

        /* report to driver */
		$scope.addReportModel = function (ev, path, model, section, mode_action) {
			if (!angular.isUndefined(mode_action)) {
				$scope.mode_action = mode_action;
			}
            $scope.currentDate = new Date();
			if($scope.mode_action == 'page') {
				$scope.controlSH = true;
				$scope.action = 'addReport';
				angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
				$scope.additionals['invalid'] = '';
				var currentModel = {};
				angular.forEach(model, function (item, key) {
					currentModel[key] = item;
				});
				$scope.modelData = currentModel;

				$scope.cancel = function () {
					$scope.modelDataDriverTraveled  = {};
					$scope.errors = {};
					$scope.controlSH = false;
				};

				Crud.get($scope.path + '/report?id='+$scope.modelData ['id'])
					.success(function (data) {
						$scope.isLoading = false;
						if (!angular.isUndefined(data.invalid)) {
							$scope.additionals['invalid'] = data.invalid;
						}
						$scope.modelDataDriverTraveled  = data;
						$scope.errors = {};
						$scope.isLoading = false;
						$scope.additionals['buttonDisabled'] = false;
					})
					.error(function (data) {
						$scope.isLoading = false;
						$scope.errors = data.errors;
						$scope.additionals['buttonDisabled'] = false;
					});

			}

			if($scope.mode_action == 'dialog') {
				$scope.additionals['invalid'] = '';
				var currentModel = {};
				angular.forEach(model, function (item, key) {
					currentModel[key] = item;
				});
				$mdDialog.show({
					controller: DialogController,
					templateUrl: 'reportDialog.tmpl.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					locals: {
						pathTemplate: $scope.pathTemplate,
						path: path,
						section: section,
						model: currentModel,
						selected: $scope.selected,
						additionals: $scope.additionals
					}
				}).then(function () {

				});
				DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'path', 'section', 'model', 'selected', 'additionals'];
				function DialogController($scope, $mdDialog, pathTemplate, path, section, model, selected, additionals) {
					$scope.pathTemplate = pathTemplate;
					$scope.path = path;
					$scope.modelData = model;
					$scope.additionals = additionals;
					$scope.selected = selected;
					$scope.section = section;

					$scope.cancel = function () {
						$mdDialog.cancel();
					};

					$scope.isLoading = true;
					Crud.get($scope.path + '/report?id='+$scope.modelData['id'])
						.success(function (data) {
							$scope.isLoading = false;
							if (!angular.isUndefined(data.invalid)) {
								$scope.additionals['invalid'] = data.invalid;
							}
							$scope.modelDataDriverTraveled = data;
							$scope.errors = {};
							$scope.isLoading = false;
							$scope.additionals['buttonDisabled'] = false;
						})
						.error(function (data) {
							$scope.isLoading = false;
							$scope.errors = data.errors;
							$scope.additionals['buttonDisabled'] = false;
						});

				}
			}
		};

		/* print report */
		$scope.printReport = function (ev, path, modelId) {

			$scope.additionals['buttonDisabled'] = true;
			var post = {};
			post['id'] = modelId;
			post['route'] = 'printReport';

			Crud.post('form-urlencoded', post, path + '/printReport')
				.success(function (data) {
					$scope.additionals['buttonDisabled'] = false;
				})
				.error(function (data) {

					$mdDialog.show({
						controller: DialogController,
						templateUrl: 'printReportDialog.tmpl.html',
						parent: angular.element(document.body),
						targetEvent: ev,
						clickOutsideToClose: true,
						locals: {pathTemplate: $scope.pathTemplate, error: data, additionals: $scope.additionals}
					}).then(function (destroyModel) {
					});
					DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'error', 'additionals'];

					function DialogController($scope, $mdDialog, pathTemplate, error, additionals) {
						$scope.pathTemplate = pathTemplate;
						$scope.cancel = function () {
							$mdDialog.cancel();
						};
						$scope.additionals = additionals;
						$scope.additionals['buttonDisabled'] = false;

						$scope.errors = error;
					}
				});

		}

		$scope.additionals['function'] = function(ev, data) {
			$scope.additionals['changeCar'] = function(carId, key) {
				if (angular.isUndefined(key)) {
					var position = $scope.additionals['cars'].map(function (e) {
						return e['id'];
					}).indexOf(parseInt(carId));
					if (position >= 0) {
						if (!angular.isUndefined($scope.additionals['cars'][position]['km_end_latest']) && $scope.additionals['cars'][position]['km_end_latest'] != null) {
							data['km_start'] = $scope.additionals['cars'][position]['km_end_latest'];
						} else {
							data['km_start'] = '';
						}
					} else {
						data['km_start'] = '';
					}
				} else {
					var position = $scope.additionals['cars'].map(function (e) {
						return e['id'];
					}).indexOf(parseInt(carId));
					if (position >= 0) {
						if (!angular.isUndefined($scope.additionals['cars'][position]['km_end_latest']) && $scope.additionals['cars'][position]['km_end_latest'] != null) {
							data[key]['km_start'] = $scope.additionals['cars'][position]['km_end_latest'];
						} else {
							data[key]['km_start'] = '';
						}
					} else {
						data[key]['km_start'] = '';
					}

				}
			}

		}

		$scope.additionals['functionResult']= function(ev, data) {

		}

		$scope.closeDayModel = function (ev, path, model) {
			$scope.modelDataCloseDay = {};
			$scope.modelDataCloseDay['id'] = model['id'];
			$scope.modelDataCloseDay['km_start'] = model['km_start'];
			$scope.modelDataCloseDay['km_end'] = model['km_end'];
			if($scope.mode_action == 'page') {
				$scope.controlSH = true;
				$scope.action = 'closeDay';
				$scope.errors = {};
				angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, 'slow');
				$scope.additionals['invalid'] = '';
				$scope.cancel = function () {
					$scope.modelDataCloseDay = {};
					$scope.errors = {};
					$scope.controlSH = false;
				};
				$scope.closeDay = function () {
					$scope.additionals['buttonDisabled'] = true;
					$scope.isLoading = true;
					var post = $scope.modelDataCloseDay;
					post['route'] = 'closeDay';
					post['id'] = model.id;
					Crud.post('form-urlencoded', post, $scope.path + '/closeDay')
						.success(function (data) {
							if (!angular.isUndefined(data.invalid)) {
								$scope.additionals['invalid'] = data.invalid;
							} else {
								if (!angular.isUndefined(data.currentModel)) {
									if (!angular.isUndefined($scope.models)) {
										$scope.getElement($scope.models, data.currentModel);
									}
								}
							}
							$scope.modelDataCloseDay = {};
							$scope.errors = {};
							$scope.isLoading = false;
							$scope.controlSH = false;
							$scope.additionals['buttonDisabled'] = false;
						})
						.error(function (data) {
							$scope.isLoading = false;
							$scope.errors = data.errors;
							$scope.additionals['buttonDisabled'] = false;
							if(data == null) {
								$rootScope.checkNetworkConnection();
							}
						});
				};
			}

			if($scope.mode_action == 'dialog') {

				$scope.modelDataCloseDay = {};
				$scope.modelDataCloseDay['id'] = model['id'];
				$scope.modelDataCloseDay['km_start'] = model['km_start'];
				$scope.modelDataCloseDay['km_end'] = model['km_end'];
				$scope.additionals['invalid'] = '';
				$scope.errors = {};
				$scope.action = 'closeDay';

				$mdDialog.show({
					controller: DialogController,
					templateUrl: 'closeDayDialog.tmpl.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					locals: {
						path: $scope.path,
						pathTemplate: $scope.pathTemplate,
						model: $scope.modelDataCloseDay,
						additionals: $scope.additionals
					}
				}).then(function () {
					if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
						if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
							if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
								$scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
							}
						}
					}
				});
				DialogController.$inject = ['$scope', '$mdDialog', 'path', 'pathTemplate', 'model', 'additionals'];
				function DialogController($scope, $mdDialog, path, pathTemplate, model, additionals) {
					$scope.path = path;
					$scope.pathTemplate = pathTemplate;
					$scope.modelDataCloseDay = model;
					$scope.additionals = additionals;
					$scope.cancel = function () {
						$mdDialog.cancel();
					};
					$scope.closeDay = function () {
						$scope.additionals['buttonDisabled'] = true;
						$scope.isLoading = true;
						var post = $scope.modelDataCloseDay;
						post['route'] = 'closeDay';
						post['id'] = model.id;
						Crud.post('form-urlencoded', post, $scope.path + '/closeDay')
							.success(function (data) {
								if (!angular.isUndefined(data.invalid)) {
									$scope.additionals['invalid'] = data.invalid;
								} else {
									if (!angular.isUndefined(data.currentModel)) {
										$scope.additionals['dataCurrentModel'] = data.currentModel;
									}
								}
								$scope.modelDataCloseDay = {};
								$scope.isLoading = false;
								$mdDialog.hide();
								$scope.additionals['buttonDisabled'] = false;
							})
							.error(function (data) {
								$scope.isLoading = false;
								$scope.errors = data.errors;
								$scope.additionals['buttonDisabled'] = false;
								if(data == null) {
									$rootScope.checkNetworkConnection();
								}
							});
					};

				}
			}

		};

        $scope.searchModel = function (ev, path) {
            $scope.search.reportType = '';
            $scope.searchControl = true;
						$scope.last = 0;
						$scope.firstTime = 1;
						$scope.firstLoad = 0;
            $scope.getPaginateModel(path, 1, $scope.defaultItem);
        }

        $scope.typeReport = 'reportDaily';
        $scope.stateReportDaily = {};
				$scope.showReport = function (action, path, offset, per_page) {
		    if(action == 'reportDaily'){
		        $scope.typeReport = 'reportDaily';
                $scope.columnsReport = {
                    'traveled_date':{'label': 'Data', 'filter': 1, 'filterType': 'input'},
                    'driver_name':{'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
                    'assigned_number':{'label': 'Numar atribuit', 'filter': 1, 'filterType': 'input'},
                    'car_no': {'label': 'Masina', 'filter': 1, 'filterType': 'input'},
                    'car_type': {'label': 'Tip masina', 'filter': 1, 'filterType': 'select', 'associate': 1},
                    //'car_type': {'label': 'Tip masina', 'filter': 1, 'filterType': 'select', 'associate': 1, 'relation': 'car', 'colRelation': 'car_no'},
                    'km_start':{'label': 'KM start', 'filter': 1, 'filterType': 'input'},
                    'km_end':{'label': 'KM end', 'filter': 1, 'filterType': 'input'},
                    'km_result':{'label': 'KM parcursi', 'filter': 1, 'filterType': 'input'},
                    'no_orders':{'label': 'Nr.comenzi livrate', 'filter': 1, 'filterType': 'input'},

                    'amount_driver_cash_collected':{'label': 'Total cash colectat', 'filter': 1, 'filterType': 'input'},
                    'amount_driver_card_collected':{'label': 'Total card colectat', 'filter': 1, 'filterType': 'input'},
                    'amount_driver_online_collected':{'label': 'Total online colectat', 'filter': 1, 'filterType': 'input'},
                    'amount_driver_bonv_collected':{'label': 'Total bonuri val. colectat', 'filter': 1, 'filterType': 'input'},
                    'amount_dispatcher_cash_collected':{'label': 'Cash predat', 'filter': 1, 'filterType': 'input'},
                    'total_costs':{'label': 'Total alte cheltuieli', 'filter': 1, 'filterType': 'input'},
                    'to_go_d':{'label': 'To_go', 'filter': 1, 'filterType': 'input'},
                    'gas_d':{'label': 'Combustibil', 'filter': 1, 'filterType': 'input'},
                    'rent_d':{'label': 'Chirie', 'filter': 1, 'filterType': 'input'},
										'total_tips':{'label': 'Tips', 'filter': 1, 'filterType': 'input'},
                    'cash_required':{'label': 'Cash de predat', 'filter': 1, 'filterType': 'input'}
                };
                $scope.columnsReport.car_type.options = $scope.additionals['car_type'];
            }

            if(action == 'reportDailyCostsCahings'){
                $scope.typeReport = 'reportDailyCostsCahings';
                $scope.columnsReport = {
                    'traveled_date':{'label': 'Data', 'filter': 1, 'filterType': 'input'},
                    'driver_name':{'label': 'Sofer', 'filter': 1, 'filterType': 'input'},
                    'cost_cashing_type':{'label': 'Tipul (cheltuieli/incasari)', 'filter': 1, 'filterType': 'input'},
                    'cost_cashing_value':{'label': 'Suma', 'filter': 1, 'filterType': 'input'},
                    'cost_cashing_reason':{'label': 'Motiv', 'filter': 1, 'filterType': 'input'}
                };
            }

            if(action == 'reportMonthly'){
                $scope.typeReport = 'reportMonthly';
                $scope.columnsReport = {
                    'traveled_date':{'label': 'Data', 'filter': 1, 'filterType': 'input'},
                    'driver_name':{'label': 'Sofer', 'filter': 1, 'filterType': 'input'},

                    'km_result':{'label': 'KM parcursi', 'filter': 1, 'filterType': 'input'},
                    'no_orders':{'label': 'Nr.comenzi livrate', 'filter': 1, 'filterType': 'input'},

                    'amount_driver_cash_collected':{'label': 'Total cash colectat', 'filter': 1, 'filterType': 'input'},
                    'amount_driver_card_collected':{'label': 'Total card colectat', 'filter': 1, 'filterType': 'input'},
                    'amount_driver_online_collected':{'label': 'Total online colectat', 'filter': 1, 'filterType': 'input'},
                    'amount_driver_bonv_collected':{'label': 'Total bonuri val. colectat', 'filter': 1, 'filterType': 'input'},
                    'amount_dispatcher_cash_collected':{'label': 'Cash predat', 'filter': 1, 'filterType': 'input'},
                    'total_costs':{'label': 'Total alte cheltuieli', 'filter': 1, 'filterType': 'input'},
                    'to_go_d':{'label': 'To_go', 'filter': 1, 'filterType': 'input'},
                    'gas_d':{'label': 'Combustibil', 'filter': 1, 'filterType': 'input'},
                    'rent_d':{'label': 'Chirie', 'filter': 1, 'filterType': 'input'},
										'total_tips':{'label': 'Tips', 'filter': 1, 'filterType': 'input'},
	                  'cash_required':{'label': 'Cash de predat', 'filter': 1, 'filterType': 'input'}
                };
            }

		    $scope.stateReportDaily.itemsPerPage = per_page;
            if (!angular.isUndefined($scope.last) && offset > $scope.last) {
               offset = $scope.last;
            }
            $scope.stateReportDaily.page = offset;

			$scope.mode_action = 'page';
			$scope.controlSH = true;
			$scope.action = action;
			$scope.errors = {};
			//angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, 'slow');
			$scope.additionals['invalid'] = '';
			$scope.cancel = function () {
				$scope.errors = {};
				$scope.controlSH = false;
			};

			if (angular.isUndefined(per_page) || per_page == 'undefined') {
				per_page = perPage;
			}
			$scope.additionals['buttonDisabledPagination'] = true;
			$scope.rangeReport = [];
			if (angular.isUndefined($scope.no_pagesReport)) {
				$scope.no_pagesReport = 1;
			}
			$scope.isLoadingPaginationReport = true;
			$scope.$watch('no_pagesReport', function (item) {
				item = $scope.no_pagesReport;
			}, true);

			$scope.additionals['buttonDisabled'] = true;
			$scope.isLoading = true;
			var post = $scope.search;
			post['route'] = 'search';
			post['reportType'] = action;
			Crud.post('form-urlencoded', post, $scope.path + '/search?page=' + offset + '&per_page=' + per_page)
				.success(function (data) {

					if (!angular.isUndefined(data.invalid)) {
						$scope.additionals['invalid'] = data.invalid;
					} else {
                        $scope.last = data.last_page;
						$scope.stopReport = data.next_page_url;
						$scope.fromReport = data.from;
						$scope.toReport = data.to;
						$scope.totalReport = data.total;
						$scope.no_pagesReport = Math.ceil(data.total / data.per_page);

						if (per_page == 0) {
							$scope.rangeReport = [{}];
						} else {
							for (var i = 0; i < $scope.no_pagesReport; i++) {
								$scope.rangeReport[i] = i;
							}
						}
						$scope.modelsReport = data.data;
						$scope.modelsReport.per_page = data.per_page;
						$scope.modelsReport.current_page = data.current_page;
					}
					$scope.isLoadingPaginationReport = false;
					$scope.additionals['buttonDisabledPagination'] = false;

					$scope.errors = {};
					$scope.isLoading = false;
					//$scope.controlSH = false;
					$scope.additionals['buttonDisabled'] = false;
				})
				.error(function (data) {
					$scope.isLoading = false;
					$scope.errors = data.errors;
					$scope.additionals['buttonDisabled'] = false;
					if(data == null) {
						$rootScope.checkNetworkConnection();
					}
				});


		};

	}]
);
